import { LabelBadgeDot } from '../../../shared/components/label-badge/label-badge';
import { FeedStatus, ProviderConfig } from '../models/provider.model';

const STATUS_DOT: Record<FeedStatus, LabelBadgeDot> = {
  PENDING: 'yellow',
  ACCEPTED: 'green',
  REJECTED: 'red',
};

/** The provider's verdict on the feed's *current* configuration. A status
 *  reported for an older revision (statusRevision < revision) doesn't cover
 *  the latest edit yet, so it reads as PENDING until the provider replies. */
export function effectiveFeedStatus(feed: Pick<ProviderConfig, 'status' | 'revision' | 'statusRevision'>): FeedStatus {
  if (feed.statusRevision == null || feed.statusRevision < feed.revision) return 'PENDING';
  return feed.status ?? 'PENDING';
}

export function feedStatusDot(status: FeedStatus): LabelBadgeDot {
  return STATUS_DOT[status];
}
